/*
 * Rotates the images of a mega menu image block (snippets/header-block.liquid).
 * Only advances while the menu is open and the tab is visible; respects reduced motion.
 * Keeps the overlay link pointing at the slide that is currently shown.
 */
(function () {
  if (customElements.get('header-image-rotator')) return;

  class HeaderImageRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.header-image-rotator__slide'));
      if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.link = this.closest('.header__dropdown__image')?.querySelector('[data-rotator-link]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = window.setInterval(() => this.next(), parseInt(this.dataset.interval, 10) || 5000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    isShown() {
      if (document.hidden || !this.getClientRects().length) return false;

      // Desktop dropdowns stay in the DOM and are only marked visible while open.
      const dropdown = this.closest('.header__dropdown');
      return !dropdown || dropdown.classList.contains('is-visible');
    }

    next() {
      if (!this.isShown()) return;

      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const upcoming = this.slides[this.index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');

      if (this.link) {
        const href = upcoming.dataset.link;
        if (href) {
          this.link.setAttribute('href', href);
        } else {
          this.link.removeAttribute('href');
        }
      }
    }
  }

  customElements.define('header-image-rotator', HeaderImageRotator);
})();
